import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { documentInformationList } from '../../model/document.model';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { UploadEvent, UploadFile, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-upload-multiple-documents',
  templateUrl: './upload-multiple-documents.component.html',
  styleUrls: ['./upload-multiple-documents.component.css']
})
export class UploadMultipleDocumentsComponent implements OnInit {
  @Output() fileAdded = new EventEmitter();
  documentInfo: documentInformationList = new documentInformationList();
  errorMsg: boolean = false;
  notvalidDocumentSize: boolean = false;
  notvalidVideoDocumentSize: boolean = false;
  filesLimit: boolean = false;
  onChangeFileName: string;
  public files: UploadFile[] = [];
  public listOfFiles: string [] = [];
  @Input('fileName') fileName: string;
  refresh: Subject<any> = new Subject();
  counter: number = 0;
  counter1: number = 0;
  counter2: number = 0;

  constructor(private ref: ChangeDetectorRef) { }

  ngOnInit() {
    this.listOfFiles.push(this.fileName);
    this.onChangeFileName = this.fileName;
  }

  onFileChange(event) {
    this.counter = 0;
    this.counter1 = 0;
    this.counter2 = 0;
    this.errorMsg = false;
    this.notvalidDocumentSize = false;
    this.notvalidVideoDocumentSize = false;
    this.listOfFiles = [];
    this.documentInfo.file = [];
    this.documentInfo.fileName = [];
    this.documentInfo.fileInput = [];

    const formInput: FormData = new FormData();
    if (event.target.files && event.target.files.length > 0) {
      if (event.target.files.length <= 20) {
        this.filesLimit = false;
        for (var i = 0; i < event.target.files.length; i++) {
          const file = event.target.files[i];
          this.onChangeFileName = file.name;
          this.files = [];
          this.listOfFiles.push(file.name);

          var extName = file.name.split('.').pop();
          var ext = extName.toLowerCase();
          if (ext == "docx" || ext == "pdf" || ext == "doc" || ext == "png" || ext == "jpg" || ext == "xls" || ext == "xlsx"
            || (environment.videoFileFormats.findIndex(val => val == file.type) >= 0)) {
            formInput.append('file', file, file.name);
            this.documentInfo.fileInput.push(formInput);
            this.documentInfo.fileName.push(file.name);
            this.documentInfo.file.push(file);

            let sizeOfFile = file.size;
            sizeOfFile = Math.ceil(sizeOfFile / (1024 * 1024));
            let defaultsize = 26;
            if (environment.videoFileFormats.findIndex(val => val == file.type) >= 0)
              defaultsize = 100;

            if (sizeOfFile >= defaultsize && environment.videoFileFormats.findIndex(val => val == file.type) >= 0) {
              this.fileAdded.emit({fileInput: formInput, fileName: "", file: []});
              this.counter2++;
            } else if (sizeOfFile >= defaultsize) {
              this.fileAdded.emit({fileInput: formInput, fileName: "", file: []});
              this.counter1++;
            } else {
              this.fileAdded.emit(this.documentInfo);
            }
          } else {
            this.fileAdded.emit({fileInput: formInput, fileName: "", file: []});
            this.counter++;
          }
        }
        if (this.counter > 0 && this.counter1 > 0 && this.counter2 > 0)
          this.errorMsg = true;
        else if (this.counter > 0)
          this.errorMsg = true;
        else if (this.counter1 > 0)
          this.notvalidDocumentSize = true;
        else if (this.counter2 > 0)
          this.notvalidVideoDocumentSize = true;
      } else {
        this.filesLimit = true;
      }
    }
  }

  public dropped(event: UploadEvent) {
   
    this.counter = 0;
    this.counter1 = 0;
    this.counter2 = 0;
    this.errorMsg = false;
    this.notvalidDocumentSize = false;
    this.notvalidVideoDocumentSize = false;
    this.listOfFiles = [];
    this.documentInfo.file = [];
    this.documentInfo.fileName = [];
    this.documentInfo.fileInput = [];
    this.files = event.files;
    const formInput: FormData = new FormData();

    for (const droppedFile of event.files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file
          this.onChangeFileName = droppedFile.relativePath;
          this.listOfFiles.push(droppedFile.relativePath);
          var extName = file.name.split('.').pop();
          var ext = extName.toLowerCase();
          if (ext == "docx" || ext == "pdf" || ext == "doc" || ext == "png" || ext == "jpg" || ext == "xls" || ext == "xlsx"
              || environment.videoFileTypes.findIndex(val => val == ext) >= 0) {
            formInput.append('file', file, file.name);
            this.documentInfo.fileInput.push(formInput);
            this.documentInfo.fileName.push(file.name);
            this.documentInfo.file.push(file);
            let sizeOfFile = file.size;
            sizeOfFile = Math.ceil(sizeOfFile / (1024 * 1024));
            let defaultsize = 26;
            if (environment.videoFileTypes.findIndex(val => val == ext) >= 0)
              defaultsize = 100;

            if (sizeOfFile >= defaultsize && environment.videoFileTypes.findIndex(val => val == ext) >= 0) {
              this.fileAdded.emit({ fileInput: formInput, fileName: "", file: []});
              this.counter2++;
            } else if (sizeOfFile >= defaultsize) {
              this.fileAdded.emit({ fileInput: formInput, fileName: "", file: []});
              this.counter1++;
            } else {
              setTimeout(() => {
                this.fileAdded.emit(this.documentInfo);
                this.ref.markForCheck();
                this.ref.detectChanges()
              }, 100);
            }
            setTimeout(() => {
              this.ref.markForCheck();
              this.ref.detectChanges()
            }, 100);
          } else {
            this.fileAdded.emit({ fileInput: formInput, fileName: "", file: []});
            this.counter++;
          }
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
    if (this.counter > 0 && this.counter1 > 0 && this.counter2 > 0)
      this.errorMsg = true;
    else if (this.counter > 0)
      this.errorMsg = true;
    else if (this.counter1 > 0)
      this.notvalidDocumentSize = true;
    else if (this.counter2 > 0)
      this.notvalidVideoDocumentSize = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/upload-multiple-documents/upload-multiple-documents.component.ts